if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
      this.deliveryStepBtns = this.querySelectorAll('.delivery-step-btn');
      this.deliveryStepBtns.forEach((btn) => {
        btn.addEventListener('click', this.onDeliveryBtnClick.bind(this));
      });

      this.deliveryStepTitles = this.querySelectorAll('.product-form__step-title-wrap');
      this.deliveryStepTitles.forEach((el) => {
        el.addEventListener('click', this.onDeliveryTitleClick.bind(this));
      });
    }

    goToStep(step) {
      const nextStepWrap = this.querySelector(`[data-step="${step}"]`);

      if (nextStepWrap) {
        const activeStep = this.querySelector('.product-form__step.active');
        activeStep.classList.remove('active')
        activeStep.classList.add('finished');
        nextStepWrap.classList.add('active');
      }
    }

    onDeliveryBtnClick(evt) {
      evt.preventDefault();
      const btn = evt.target;
      const nextStep = btn.dataset.next;
      this.goToStep(nextStep);
    }

    onDeliveryTitleClick(evt) {
      evt.preventDefault();
      const title = evt.target;
      const stepWrap = title.closest('[data-step]');

      if (stepWrap.classList.contains('finished')) {
        const step = stepWrap.dataset.step;
        this.goToStep(step);
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();      

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      let uuid = (new URL(window.location)).searchParams.get('uuid');
      if (uuid) {
        formData.append('properties[_parentId]', uuid);
      } else {
        uuid = `${new Date().getTime()}`.slice(5);
        formData.append('properties[_bundleId]', uuid);
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      if (!formData.get('items[0][id]')) {
        formData.delete('items[0][id]');
        formData.delete('items[0][quantity]');
      } else {
        formData.append('items[0][properties][_parentId]', uuid);
      }

      if (!formData.get('items[1][id]')) {
        formData.delete('items[1][id]');
        formData.delete('items[1][quantity]');
      } else {
        formData.append('items[1][properties][_parentId]', uuid);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const hasRedirect = !!formData.get('redirect');

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else if (!hasRedirect ) {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          if (!this.error && formData.get('redirect')) {
            const redirectUrl = formData.get('redirect');

            window.location = `${redirectUrl}&uuid=${uuid}`;
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

const toggleDeliveryBtn = (active) => {
  const deliveryBtn = document.querySelector('[data-product-delivery-btn]');
  if (deliveryBtn) {
    deliveryBtn.disabled = !active;
  }
};

window.ZapietEvent.listen('selected_method', function() {    
  toggleDeliveryBtn(false);
});


window.ZapietEvent.listen('checkoutEnabled', function(options) {    
  toggleDeliveryBtn(true);
  localStorage.setItem('selectedDelivery', JSON.stringify(options));
});

window.ZapietEvent.listen('delivery.datepicker.rendered', function() {    
  toggleDeliveryBtn(false);
});

const productDeliveryWrap = document.querySelector('.product-form__step--delivery');
if (productDeliveryWrap) {
  productDeliveryWrap.addEventListener('change', function(e) {
    const target = e.target;
    
    if (target.id === 'deliveryGeoSearchField') {
      toggleDeliveryBtn(false);
    }
  });

  productDeliveryWrap.addEventListener('click', function(e) {
    const target = e.target;
    
    if (target.classList.contains('picker__day')) {
      localStorage.setItem('selectedDeliveryDate', target.dataset.pick);
    }
  }, true);
}

const giftCardCounter = document.querySelector('.gift-card-character-count');
if (giftCardCounter) {
  const counterWrap = giftCardCounter.closest('.field');
  const counterField = counterWrap.querySelector('textarea');
  const counterCurrent = giftCardCounter.querySelector('.gift-card-character-count__current');

  if (counterField) {
    counterField.addEventListener('keyup', (e) => {
      const value = e.target.value;
      const length = value.length;
      counterCurrent.innerHTML = length;
    });
  }
}


if (!customElements.get('buy-now')) {
  customElements.define('buy-now', class BuyNow extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.button');
      this.button.addEventListener('click', this.handleClick.bind(this));
      
      this.qtySelector = document.querySelector('.product__info-container quantity-input');      
    }

    handleClick(e) {
      e.preventDefault();
      const qty = this.qtySelector ? this.qtySelector.input.value : 1;
      this.variantId = this.button.dataset.variant;
      
      window.location = `/cart/${this.variantId}:${qty}`;
    }
  });
}